import { MatToolbarModule } from '@angular/material/toolbar'
import { MatListModule } from '@angular/material/list'
import { MatSidenav, MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav'
import { Component, inject, ViewChild } from '@angular/core'
import { Router, RouterLink, RouterOutlet } from '@angular/router'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { Store } from '@ngrx/store'
import { getClient } from '@monorepo-channels/channels/domain'
import { DataLayerService, isMobile, MenuOpened } from '@monorepo-channels/shared/util-helpers'
import { MatDialog } from '@angular/material/dialog'
import { take } from 'rxjs'
import { ExitComponent } from '../dialog/exit.component.ts'

@Component({
	selector: 'feature-porto-bank-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
	imports: [
		CommonModule,
		MatSidenavModule,
		MatButtonModule,
		RouterLink,
		RouterOutlet,
		MatIconModule,
		MatSidenavContent,
		MatToolbarModule,
		MatIconModule,
		MatListModule,
		MatButtonModule,
	],
	standalone: true,
})
export class MenuComponent {
	private store = inject(Store)
	public client$ = this.store.select(getClient)
	public dialog = inject(MatDialog)
	public router = inject(Router)
	private menuOpened = inject(MenuOpened)
	private dataLayerService = inject(DataLayerService)
	isMobile = isMobile()
	sidenavMode: 'over' | 'side' = this.isMobile ? 'over' : 'side'

	@ViewChild('sidenav') sidenav!: MatSidenav

	onOpenedChange(opened: boolean) {
		this.menuOpened.sidenavOpened = opened
	}

	toggle() {
		this.sidenav.toggle()
		this.menuOpened.sidenavOpened = this.sidenav.opened
	}

	redirectClick() {
		this.dataLayerService.logEvent({
			event: 'button_clicked',
			screen_name: 'STICKY_BANNER',
			button_name: 'PECA_SEU_CARTAO',
		})
		window.open('https://www.portoseguro.com.br/loja/cartao-de-credito/aquisicao', '_blank')
	}

	logout() {
		this.client$.pipe(take(1)).subscribe(client => {
			this.dialog.open(ExitComponent, {
				data: { client: client?.firstName },
				width: '400px',
			})
		})
	}
}
